import { Lookup } from './lookup.interface';

export const FiRelations: { [name: string]: Lookup } = {
  parent: { displayValue: 'Parent', code: 'parent' },
  other: { displayValue: 'Legal guardian (other)', code: 'other' },
};
